module.exports = __webpack_public_path__ + "images/ExternalPromo/wix-footer-381.png?1f08a";